import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import DisableDevtool from 'disable-devtool';

if (process.env.NODE_ENV === 'production') {
  DisableDevtool();
}
Vue.config.productionTip = false

Vue.directive('add-class', {
  bind(el, binding) {
    el.className += ' ' + binding.value;
  }
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
